const { generateLayout } = require("./gatsby-common")
require("./src/css/tailwind.build.css")

exports.wrapPageElement = ({ element, props }) => {
  return generateLayout({ element, props })
}
